import apiService from 'services';

export interface ModelPerson {
  userId: number;
  name: string;
  email: string;
}

interface AccessRow {
  user_id?: number;
  firstname?: string | null;
  lastname?: string | null;
  username?: string | null;
  orgnization_name?: string | null;
}

const personName = (row: AccessRow) => {
  const name = [row.firstname, row.lastname].filter(Boolean).join(' ').trim();
  return name || row.username || 'Teammate';
};

/** People already linked to the model, the same list the Share control uses. */
export const listModelPeople = async (modelId: number): Promise<ModelPerson[]> => {
  const response = await apiService.get_share_model_users(modelId);
  const rows: AccessRow[] = Array.isArray(response.data) ? response.data : [];
  return rows
    .filter((row) => typeof row.user_id === 'number' && row.orgnization_name !== 'anonymous')
    .map((row) => ({
      userId: row.user_id as number,
      name: personName(row),
      email: row.username ?? '',
    }))
    .sort((left, right) => left.name.localeCompare(right.name));
};
